import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { getApiHeader } from 'utlis/commonfunctions';
import axios from 'axios';
import Alert from '@mui/material/Alert';
import { Grid, Card, CardHeader, CardMedia, CardContent, Typography, Button, Input, Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText, TextField, Box, Backdrop, CircularProgress } from '@mui/material';
import Invoice from './Invoice';
import WarningIcon from '@mui/icons-material/Warning';


const SERVER_URL = process.env.REACT_APP_API_URL;

function FreeAccessoriesStockAllocation() {
    const [pid, setPid] = useState('');
    const [retailerInfo, setRetailerInfo] = useState(null);
    const [accessories, setAccessories] = useState([]);
    const [selectedAccessories, setSelectedAccessories] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [open, setOpen] = useState(false);
    const [invoicePage, setInvoicePage] = useState(false)
    const [invoiceRetailerDetail, setInvoiceRetailerDetail] = useState({})
    const [invoiceOrderDetail, setInvoiceOrderDetail] = useState({})
    const [invoiceAccessories, setInvoiceAccessories] = useState([])

    const handlePidChange = (e) => {
        setPid(e.target.value);
    };

    const fetchRetailerData = async (pid) => {
        const url = `${SERVER_URL}accessories/get-retailer-accessories-info`;

        const headers = await getApiHeader();

        try {
            const formData = new URLSearchParams();
            formData.append('retailer_code', pid);

            const response = await axios.post(url, formData, {
                headers: headers,
            });

            if (response.data.status === 200) {
                const { retailer_name, retailer_company_name, retailer_code, retailer_address, accessories } = response.data.data;

                return {
                    retailerInfo: {
                        name: retailer_name,
                        company: retailer_company_name,
                        address: retailer_address,
                        pid: retailer_code
                    },
                    accessories: accessories.map((accessory) => ({
                        id: accessory.accessory_id,
                        name: accessory.product_name,
                        description: accessory.description,
                        amount: accessory.amount,
                        sellAmount: accessory.sell_amount,
                        discountApplied: accessory.discount_amount,
                        image: accessory.image,
                        allowableStock: accessory.assigned_accessory_limit,
                        totalAssignedStock: accessory.total_assigned_stock
                    })) || [],
                };

            } else {
                throw new Error(response.data.message || 'Error fetching data');
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            throw new Error(error.response.data.message || 'Error fetching data');
        }
    };

    const handleFetchData = async () => {
        setLoading(true);
        setError(null);
        setSelectedAccessories({})
        setAccessories([])
        setRetailerInfo(null)

        try {
            const data = await fetchRetailerData(pid);
            setRetailerInfo(data.retailerInfo);
            setAccessories(data.accessories);
        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    const handleQuantityChange = (id, value) => {
        console.log("id--------->", id);
        console.log("value------>", value);

        const accessory = accessories.find(item => item.id === id);

        console.log("allowableStock----->", accessory.allowableStock);

        if (typeof value === 'number' && !Number.isNaN(value)) {
            const updatedQuantity = Math.max(0, Math.min(value, accessory.allowableStock));

            setSelectedAccessories(prev => ({
                ...prev,
                [id]: updatedQuantity
            }));

            console.log("selectedAccessories------>", selectedAccessories);
        } else {
            setSelectedAccessories(prev => ({
                ...prev,
                [id]: 0
            }));

            console.log("Invalid value: not a number, setting quantity to 0");
        }
    };





    const selectedForCheckout = Object.entries(selectedAccessories)
        .filter(([id, quantity]) => quantity > 0)
        .map(([id, quantity]) => {
            const accessory = accessories.find(item => item.id === parseInt(id));
            return { ...accessory, quantity };
        });


    const handleSubmit = async () => {
        setOpen(false);
        setLoading(true);
        setError(null);

        try {
            const formattedAccessories = Object.keys(selectedAccessories)
                .filter(accessory_id => selectedAccessories[accessory_id] > 0)
                .map(accessory_id => ({
                    accessory_id: parseInt(accessory_id),
                    quantity: selectedAccessories[accessory_id]
                }));

            const requestBody = {
                retailer_code: pid,
                accessories: formattedAccessories
            };

            const url = `${SERVER_URL}accessories/allocate-accessories`;
            const headers = await getApiHeader();
            const response = await axios.post(url, requestBody, { headers: headers });

            if (response.data.status === 200) {
                setInvoiceOrderDetail(response.data.data.order_details);
                setInvoiceRetailerDetail(response.data.data.retailer_details);
                setInvoiceAccessories(response.data.data.accessories_product_details);
                setInvoicePage(true);
            } else {
                setError(response.data.message);
            }

            console.log("API Response:", response.data);
        } catch (error) {
            setError(error.response?.data?.message || 'Error fetching data');
        } finally {
            setLoading(false);
        }
    };



    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };


    return (
        <DashboardLayout>
            <DashboardNavbar />


            {invoicePage ? (

                <Invoice retaileDetail={invoiceRetailerDetail} orderDetail={invoiceOrderDetail} accessories={invoiceAccessories}></Invoice>
            ) : (
                <Box
                    className="container mt-4 p-5"
                    sx={{
                        backgroundColor: "#fff",
                        boxShadow: "rgb(204, 219, 232) 3px 3px 6px 0px inset, rgba(255, 255, 255, 0.5) -3px -3px 6px 1px inset",
                        borderRadius: '12px',
                        width: { xs: "100%", sm: "90%", md: "90%" },
                        padding: { xs: "1rem", sm: "2rem", md: "5rem" },
                    }}
                >
                    <h5>Search and Allocate Accessories </h5>
                    <Box className="mb-4 d-flex align-items-center mt-4" sx={{ flexDirection: { xs: "column", sm: "row" } }}>
                        <Typography variant="body1" className="me-3" sx={{ mb: { xs: 2, sm: 0 } }}>
                            Retailer ID<span className="text-danger">*</span>
                        </Typography>
                        <Box className="flex-grow-1" sx={{ width: { xs: "100%", sm: "auto" } }}>
                            <TextField
                                id="pidInput"
                                type="text"
                                fullWidth
                                variant="outlined"
                                placeholder="Enter Retailer ID"
                                value={pid}
                                onChange={handlePidChange}
                                InputProps={{
                                    style: { borderRadius: '5px' },
                                }}
                                autoComplete='off'
                            />
                        </Box>
                        <button
                            className="ms-3"
                            onClick={handleFetchData}
                            disabled={loading}
                            style={{
                                borderTopLeftRadius: '8px',
                                borderBottomRightRadius: '8px',
                                backgroundColor: '#C11D6C',
                                color: 'white',
                                border: 'none',
                                padding: '5px 16px',
                                cursor: 'pointer',
                                width: { xs: "100%", sm: "auto" },
                                marginTop: { xs: "1rem", sm: "0" },
                                margin: '10px',
                            }}
                        >
                            Search
                        </button>

                    </Box>

                    {loading && (
                        <Backdrop
                            open={true}
                            style={{
                                color: '#fff',
                                zIndex: 9999,
                            }}
                        >
                            <CircularProgress color="inherit" />
                        </Backdrop>
                    )}

                    {error && (
                        <Alert variant="outlined" severity="error" className="mb-4">
                            {error}
                        </Alert>
                    )}
                    {retailerInfo && (
                        <Card sx={{ borderRadius: '15px', boxShadow: 3, overflow: 'hidden', mb: 4 }}>
                            <CardHeader
                                sx={{ backgroundColor: '#f8f9fa', borderBottom: 'none' }}
                                title={
                                    <Typography variant="h5" component="div">
                                        Retailer Information
                                    </Typography>
                                }
                            />

                            <CardContent sx={{ backgroundColor: '#ffffff', textAlign: 'left' }}>

                                <Typography
                                    variant="body1"
                                    sx={{ fontSize: '1.2rem', color: '#6c757d', marginBottom: '1.5rem' }}
                                >
                                    <strong> Dealer Name:</strong> <span >{retailerInfo.name}</span>
                                </Typography>

                                <Typography
                                    variant="body1"
                                    sx={{ fontSize: '1.2rem', color: '#6c757d', marginBottom: '1.5rem' }}
                                >
                                    <strong> Company/Store Name:</strong> <span >{retailerInfo.company}</span>
                                </Typography>
                                <Typography
                                    variant="body1"
                                    sx={{ fontSize: '1.2rem', color: '#6c757d', marginBottom: '1.5rem' }}
                                >
                                    <strong>Dealer Address:</strong> <span >{retailerInfo.address}</span>
                                </Typography>


                            </CardContent>
                        </Card>
                    )}
                    {accessories.length > 0 && (
                        <Grid container spacing={4}>

                            {accessories.map((accessory) => (
                                <Grid item xs={12} md={6} lg={4} key={accessory.id}>

                                    <Card
                                        sx={{
                                            height: '100%',
                                            borderRadius: '20px',
                                            boxShadow: '0px 8px 20px rgba(0, 0, 0, 0.1)',
                                            overflow: 'hidden',
                                            transition: 'transform 0.3s ease-in-out',
                                            '&:hover': { transform: 'scale(1.05)' },
                                        }}
                                    >
                                        <CardMedia
                                            component="img"
                                            image={accessory.image}
                                            alt={accessory.name}
                                            sx={{
                                                height: { xs: "200px", sm: "250px" },
                                                objectFit: 'contain',
                                                transition: 'opacity 0.3s ease',
                                                '&:hover': { opacity: 0.8 },
                                            }}
                                        />
                                        <CardContent
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'space-between',
                                                padding: '16px',
                                                backgroundColor: '#fFF',
                                            }}
                                        >

                                            <Typography variant="h6" component="div" color="textPrimary" gutterBottom>
                                                {accessory.name}
                                            </Typography>
                                            <Typography variant="body2" color="textSecondary" sx={{ marginBottom: 2 }}>
                                                Available Stock: <strong style={{ color: accessory.totalAssignedStock > 0 ? '#4caf50' : '#f44336', fontSize: '16px' }}>
                                                    {accessory.totalAssignedStock}
                                                </strong>
                                                {accessory.totalAssignedStock === 0 && (
                                                    <>
                                                        <br />
                                                        <Box
                                                            component="span"
                                                            sx={{
                                                                color: '#f44336',
                                                                fontWeight: 'bold',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '5px',
                                                                fontSize: '14px',
                                                            }}
                                                        >
                                                            <WarningIcon sx={{ fontSize: '16px' }} />
                                                            Out of Stock
                                                        </Box>
                                                    </>
                                                )}
                                            </Typography>

                                            {accessory.allowableStock > 0 && (
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', gap: '8px' }}>
                                                    <Button
                                                        variant="contained"
                                                        sx={{
                                                            background: 'linear-gradient(135deg, #c11d6c 0%, #ff4081 100%)',
                                                            color: '#ffffff',
                                                            minWidth: '45px',
                                                            height: '45px',
                                                            borderRadius: '10px 0px 10px 0px',
                                                            padding: 0,
                                                            fontSize: '20px!important',
                                                            fontWeight: '900!important',
                                                            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)',
                                                            transition: 'all 0.3s ease',
                                                            '&:hover': {
                                                                background: 'linear-gradient(135deg, #ff4081 0%, #c11d6c 100%)',
                                                                boxShadow: '0 6px 15px rgba(0, 0, 0, 0.2)',
                                                            },
                                                            '&:disabled': {
                                                                background: '#e0e0e0',
                                                                color: '#9e9e9e',
                                                            },
                                                        }}
                                                        onClick={() => handleQuantityChange(accessory.id, (selectedAccessories[accessory.id] || 0) - 1)}
                                                        disabled={(selectedAccessories[accessory.id] || 0) <= 0}
                                                    >
                                                        -
                                                    </Button>
                                                    <TextField
                                                        value={selectedAccessories[accessory.id] || 0}
                                                        onChange={(e) => handleQuantityChange(accessory.id, parseInt(e.target.value, 10))}
                                                        inputProps={{
                                                            style: {
                                                                width: '100%',
                                                                textAlign: 'center',
                                                                fontWeight: 'bold',
                                                                padding: '16px',
                                                                fontSize: '16px',
                                                                borderRadius: '5px',
                                                            },
                                                            type: 'number',
                                                            min: 0,
                                                            max: accessory.allowableStock,
                                                        }}
                                                        sx={{
                                                            width: "100%",
                                                            textAlign: "center",
                                                            padding: "16px",
                                                            "& .MuiOutlinedInput-root": {
                                                                borderRadius: "10px",
                                                                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                                                                transition: "box-shadow 0.3s ease",
                                                                "&:hover fieldset": {
                                                                    boxShadow:
                                                                        "0px 6px 12px rgba(0, 0, 0, 0.15)",
                                                                },
                                                            },
                                                        }}
                                                    />
                                                    <Button
                                                        variant="contained"
                                                        sx={{
                                                            background: 'linear-gradient(135deg, #c11d6c 0%, #ff4081 100%)',
                                                            color: '#ffffff',
                                                            minWidth: '45px',
                                                            height: '45px',
                                                            margin: '10px',
                                                            fontSize: '20px!important',
                                                            fontWeight: '900!important',
                                                            borderRadius: '10px 0px 10px 0px',
                                                            padding: 0,
                                                            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)',
                                                            transition: 'all 0.3s ease',
                                                            '&:hover': {
                                                                background: 'linear-gradient(135deg, #ff4081 0%, #c11d6c 100%)',
                                                                boxShadow: '0 6px 15px rgba(0, 0, 0, 0.2)',
                                                            },
                                                            '&:disabled': {
                                                                background: '#e0e0e0',
                                                                color: '#9e9e9e',
                                                            },
                                                        }}
                                                        onClick={() => handleQuantityChange(accessory.id, (selectedAccessories[accessory.id] || 0) + 1)}
                                                        disabled={(selectedAccessories[accessory.id] || 0) >= accessory.allowableStock}
                                                    >
                                                        +
                                                    </Button>
                                                </div>
                                            )}
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    )}














                    {selectedForCheckout.length > 0 && (
                        <Box className="mt-4 ">
                            <h6>Checkout Summary:</h6>

                            <table className="table table-bordered accessory-table">
                                <thead>
                                    <tr className="head">
                                        <td>SL.No</td>
                                        <td className="text-center">PRODUCT</td>
                                        <td className="text-center">UNIT PRICE</td>
                                        <td className="text-center">QUANTITY</td>
                                        <td className="text-center">SUBTOTAL</td>
                                        <td className="text-center">DISCOUNT</td>
                                        <td className="text-center">NET PRICE</td>
                                        <td className="text-center"></td>
                                    </tr>
                                </thead>
                                <tbody id="accessory-table-body">
                                    {selectedForCheckout.map((accessory, index) => {
                                        const price = accessory.sellAmount || 0;
                                        const quantity = accessory.quantity || 0;
                                        const subtotal = price * quantity;
                                        const discount = accessory.discountApplied * quantity || 0;
                                        const netTotal = subtotal - discount;

                                        return (
                                            <tr key={accessory.id}>
                                                <td>{index + 1}</td>
                                                <td>{accessory.name}</td>
                                                <td className="text-center">${price.toFixed(2)}</td>
                                                <td className="text-center">{quantity}</td>
                                                <td className="text-center">${subtotal.toFixed(2)}</td>
                                                <td className="text-center">${discount.toFixed(2)}</td>
                                                <td className="text-center">${netTotal.toFixed(2)}</td>
                                                <td className="text-center">
                                                    <button
                                                     style={{color:"white",backgroundColor:"#C11D6C"}} 
                                                        className="btn"
                                                        onClick={() => handleQuantityChange(accessory.id, 0)}
                                                    >
                                                        Remove
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>

                            <Box className="mt-3">
                                <Box className="d-flex justify-content-between mb-2">
                                    <Typography variant="body1">Total Amount:</Typography>
                                    <Typography variant="body1">
                                        ${selectedForCheckout.reduce((total, accessory) => {
                                            const price = accessory.sellAmount || 0;
                                            const quantity = accessory.quantity || 0;
                                            return total + (price * quantity);
                                        }, 0).toFixed(2)}
                                        {/* calculation for total amount */}
                                    </Typography>
                                </Box>
                                <Box className="d-flex justify-content-between mb-2">
                                    <Typography variant="body1">Discount Applied:</Typography>
                                    <Typography variant="body1" color="error">
                                        {/* Discount calculation  */}
                                        -${selectedForCheckout.reduce((total, accessory) => {

                                            const quantity = accessory.quantity || 0;
                                            return total + (accessory.discountApplied * quantity || 0);
                                        }, 0).toFixed(2)}
                                    </Typography>
                                </Box>
                                <Box className="d-flex justify-content-between mb-3 font-weight-bold">
                                    <Typography variant="body1" fontWeight="bold">Grand Total:</Typography>
                                    <Typography variant="body1">
                                        ${(
                                            selectedForCheckout.reduce((total, accessory) => {
                                                const price = accessory.sellAmount || 0;
                                                const quantity = accessory.quantity || 0;
                                                return total + (price * quantity);
                                            }, 0) -
                                            selectedForCheckout.reduce((total, accessory) => {
                                                return total + (accessory.discountApplied * accessory.quantity || 0);
                                            }, 0)
                                        ).toFixed(2)}
                                        {/* calculation for amount of final  */}
                                    </Typography>
                                </Box>
                                {/* <Button
                                    variant="contained"
                                    fullWidth
                                    sx={{ backgroundColor: '#C11D6C', color: "#FFF", '&:hover': { backgroundColor: '#A61252' } }}
                                    onClick={handleClickOpen} >
                                    Checkout
                                </Button> */}
                                <button variant="contained" className="btn checkout-button-long" onClick={handleClickOpen} >Checkout</button>
                            </Box>
                        </Box>
                    )}
                </Box>
            )
            }
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="confirm-dialog-title"
                aria-describedby="confirm-dialog-description"
            >
                <DialogTitle id="confirm-dialog-title">Confirm Checkout</DialogTitle>
                <DialogContent>
                    <DialogContentText id="confirm-dialog-description"  className='addPaymentMethodDailouge'>
                        Are you sure you want to proceed with the checkout?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} style={{color:"white",backgroundColor:"#C11D6C"}}>
                        Cancel
                    </Button>
                    <Button onClick={handleSubmit}style={{color:"white",backgroundColor:"#C11D6C"}} autoFocus>
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </DashboardLayout>
    );
}

export default FreeAccessoriesStockAllocation;
